import './WebViewJavascriptBridge.js' // 与app交互
import vuet from '@/vuet'
import config from '@/util/config'

const {
  userAgent
} = navigator

// 封装和ios进行交互
const getCallBackName = (function () {
  let id = 0

  return function () {
    return '_native_callback_' + id++
  }
})()

function actionWithIos (type, args = {}) {
  if (args.callback) {
    const callBackName = getCallBackName()
    window[callBackName] = args.callback
    args.callback = callBackName
  }

  window.webkit.messageHandlers[type].postMessage(args)
}
// 封装和Android进行交互
function actionWithAndroid (type, args = {}) {
  const callback = args.callback
  if (callback) {
    delete args.callback
  }
  return window.WebViewJavascriptBridge.callHandler(
    type,
    args,
    callback
  )
}

function actionWithNative (type, arg = {}) {
  if (/jrfwAndroid/i.test(userAgent)) {
    return actionWithAndroid(type, arg)
  } else if (/jrfwiOS/i.test(userAgent)) {
    return actionWithIos(type, arg)
  } else {
    // alert('交互异常')
  }
}

// 获取用户信息
function getUserInfo (params) {
  return new Promise(function (resolve, reject) {
    actionWithNative('getUserInfo', Object.assign({
      callback: function (res) {
        resolve(typeof (res) === 'string' ? JSON.parse(res) : res)
      }
    }))
  })
}

// 刷新定位
function getlocation () {
  return new Promise(function (resolve, reject) {
    actionWithNative('refreshLocation', Object.assign({
      callback: function (res) {
        resolve(typeof (res) === 'string' ? JSON.parse(res) : res)
      }
    }))
  })
}

// 调起分享面板
function setShare (params) {
  return actionWithNative('setShare', params)
}
// 网店小程序分享
function wxminiShare (params) {
  return actionWithNative('wxminiShare', params)
}

// 页面跳转通用方法
function clickToApp (params) {
  return actionWithNative('click', params)
}

// 聊天
function gochat (id, name) {
  clickToApp({
    page: 'customer',
    event: 'chat',
    id: id,
    name: name
  })
}
// 新房详情
function gonewhouse (id) {
  clickToApp({
    page: 'shop',
    event: 'newhousedetail',
    id: id + ''
  })
}
// 二手房详情
function gosecond (id, rid, type) {
  clickToApp({
    page: 'shop',
    event: 'seconddetail',
    id: id + '',
    relaseId: rid + '',
    type: type
  })
}
// 租房详情
function gorent (id, rid, type) {
  clickToApp({
    page: 'shop',
    event: 'rentdetail',
    id: id + '',
    relaseId: rid + '',
    type: type
  })
}
// 房源管理
function gohousemanger () {
  clickToApp({
    page: 'customer',
    event: 'housemanager'
  })
}

// 约看列表
function goSeeing () {
  clickToApp({
    page: 'customer',
    event: 'customerSeeing',
    id: id + '',
    relaseId: rid + ''
  })
}

// 通讯录导入
function getContacts () {
  return new Promise(function (resolve, reject) {
    actionWithNative('getContacts', Object.assign({
      callback: function (res) {
        resolve(typeof (res) === 'string' ? JSON.parse(res) : res)
      }
    }))
  })
}
// 新房
function goNewHouse (id) {
  actionWithNative('checkNewHouseDetail', id)
}
// 二手房
function goSecond (releaseid) {
  actionWithNative('checkUsedHouseDetail', releaseid)
}

// // 新建一个webview堆栈 打开H5
// function openWebview (params) { return actionWithNative('openWebview', params) }

// 点击返回
function back (params) {
  return actionWithNative('back', params)
}

// 拨打电话
function call (phone) {
  return actionWithNative('dialPhone', {
    phone: phone
  })
}

// 拷贝
function copy (content) {
  return actionWithNative('copyString', {
    content: content
  })
}

// 多选城市 今日房网 李明洋 独用
function multipleSelectCity (params) {
  return actionWithNative('multipleSelectCity', params)
}

function goPropertyDetail (params) {
  if (window.jrfw.isIos()) {
    actionWithIos('goPropertyDetail', params)
  } else {
    actionWithAndroid('goPropertyDetail', params)
  }
}

export default {
  goSeeing: goSeeing,
  wxminiShare: wxminiShare,
  gohousemanger: gohousemanger,
  gochat: gochat,
  gonewhouse: gonewhouse,
  gosecond: gosecond,
  gorent: gorent,
  call: call,
  copy: copy,
  goNewHouse: goNewHouse,
  goSecond: goSecond,
  getContacts: getContacts,
  getUserInfo: getUserInfo,
  getlocation: getlocation,
  setShare: setShare,
  clickToApp: clickToApp,
  // openWebview: openWebview,
  back: back,
  multipleSelectCity: multipleSelectCity,
  goPropertyDetail: goPropertyDetail
}
